var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"t-data":"status-chip","text-color":_vm.statusTextColor(_vm.status),"color":_vm.statusFillColor(_vm.status),"dark":""}},[_vm._v(" "+_vm._s(_vm.statusName(_vm.status))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }